// React
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// Fe
import { FikscopeEngine, fikscope_input_type, GameStateBase } from "../../fikscopeengine_modules/fikscopeengine-core";
// Level
import { LMSphere } from "./level/LMSphere";

export function Sphere360(props: any) {
	const language: string = useSelector((state: any) => state.user.language);

	let [fe, setFe] = useState<FikscopeEngine>();

	useEffect(() => {
		if (fe) {
			props.setMaxSize(fe.renderer.capabilities.maxTextureSize);
		}
	}, [props, fe]);

	useEffect(() => {
		if (language) {
			const container = document.getElementById("viewport");

			const gs = new GameStateBase({
				map: new LMSphere({
					lang: language,
				}),
			});

			const args: fikscope_input_type = {
				graphic_enabled: true,
				input_enabled: true,
				physic_enabled: true,
				container: container,
				multi: false,
				gameState: gs,
			};

			setFe(new FikscopeEngine(args));
		}
	}, [language]);

	return (
		<React.Fragment>
			{/* Viewport */}
			<div
				id='viewport'
				style={{
					opacity: 1,
					top: 0,
					left: 0,
					position: "absolute",
					width: "100%",
					height: "100%",
					margin: "auto",
					pointerEvents: "all",
				}}
			/>
		</React.Fragment>
	);
}
